import React from 'react';
import styled, { keyframes } from 'styled-components';

// Spinner animation
const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// Pulsating animation for the overlay
const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.7;
  }
`;

const LoaderOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6); /* Dark semi-transparent backdrop */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* High z-index to ensure it's above everything else */
  animation: ${pulse} 2s infinite; /* Pulsating effect */
`;

const Spinner = styled.div`
  display: inline-block;
  width: 60px; /* Adjusted size for elegance */
  height: 60px; /* Adjusted size for elegance */
  border-radius: 50%;
  border: 6px solid rgba(255, 255, 255, 0.3);
  border-top-color: #4a90e2; /* Change to a softer blue color */
  animation: ${rotate} 0.8s linear infinite; /* Slightly faster rotation */
`;

const Text = styled.div`
  margin-top: 15px;
  color: white; /* Text color */
  font-size: 18px; /* Adjusted font size */
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; /* Font family */
  text-align: center; /* Centered text */
  animation: fadeIn 0.5s ease-in-out; /* Smooth text appearance */
`;

// Keyframes for text fading
const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const Loader = () => (
  <LoaderOverlay>
    <div style={{ textAlign: 'center' }}>
      <Spinner />
      <Text>Loading, please wait...</Text>
    </div>
  </LoaderOverlay>
);

export default Loader;
